import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';

export default function CGU() {
  return (
    <div className="min-h-screen">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Bouton retour */}
        <Link
          to="/"
          className="inline-flex items-center text-honey-600 hover:text-honey-700 mb-8"
        >
          <ArrowLeftIcon className="h-5 w-5 mr-2" />
          Retour à l'accueil
        </Link>

        {/* Titre */}
        <h1 className="text-3xl font-bold text-slate-900 mb-8">
          Charte d'utilisation de la plateforme
        </h1>

        {/* Contenu */}
        <div className="bg-white rounded-xl shadow-sm p-8 space-y-8">
          {/* 1. Objet */}
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-4">1. Objet</h2>
            <p className="text-slate-600 leading-relaxed text-justify">
              La présente charte définit les règles d'utilisation de la plateforme abeillereunion.re.
            </p>
          </section>

          {/* 2. Engagements de l'adhérent */}
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-4">2. Engagements de l'adhérent</h2>
            <p className="text-slate-600 leading-relaxed mb-4 text-justify">
              L'adhérent s'engage à :
            </p>
            <ul className="list-disc list-inside text-slate-600 space-y-2 ml-4">
              <li>Fournir des informations exactes et sincères</li>
              <li>Respecter les règlements et décisions du SAR</li>
              <li>Utiliser la plateforme de manière loyale</li>
            </ul>
          </section>

          {/* 3. Accès à la plateforme */}
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-4">3. Accès à la plateforme</h2>
            <p className="text-slate-600 leading-relaxed text-justify">
              L'accès est strictement personnel. L'adhérent est responsable de la confidentialité de ses identifiants.
            </p>
          </section>

          {/* 4. Sanctions */}
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-4">4. Sanctions</h2>
            <p className="text-slate-600 leading-relaxed text-justify">
              En cas de non-respect des règles, le SAR se réserve le droit de suspendre ou de supprimer l'accès à la plateforme.
            </p>
          </section>

          {/* 5. Évolution */}
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-4">5. Évolution</h2>
            <p className="text-slate-600 leading-relaxed text-justify">
              La présente charte peut être modifiée à tout moment. Les adhérents seront informés des mises à jour.
            </p>
          </section>
        </div>

        {/* Date de mise à jour */}
        <p className="text-sm text-slate-500 mt-6 text-center">
          Dernière mise à jour : Janvier 2026
        </p>
      </div>
    </div>
  );
}
